import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { getFeatures } from "../connectors/featuresApi";

export type Feature =
  | "transfers"
  | "operate"
  | "echeqs"
  | "dollar_mep"
  | "performance"
  | "report_bottom";

const useFeatures = () => {
  const { data: features } = useQuery({
    queryFn: getFeatures,
    queryKey: ["getFeatures"],
    select: (response) => response.data,
    staleTime: 1000 * 60 * 15,
  });

  const isFeatureEnabled = useCallback(
    (featureName: Feature) =>
      features?.find(({ name }) => name === featureName)?.enabled !== false,
    [JSON.stringify(features)]
  );

  const isFeatureDisabled = (featureName: Feature) =>
    !isFeatureEnabled(featureName);

  return useMemo(
    () => ({
      isFeatureEnabled,
      isFeatureDisabled,
      isTransfersEnabled: isFeatureEnabled("transfers"),
      isOperateEnabled: isFeatureEnabled("operate"),
      isEcheqsEnabled: isFeatureEnabled("echeqs"),
      isMepEnabled: isFeatureEnabled("dollar_mep"),
      isValuationReturnsEnabled: isFeatureEnabled("performance"),
      isReportsEnabled: isFeatureEnabled("report_bottom"),
    }),
    [JSON.stringify(features), isFeatureEnabled, isFeatureDisabled]
  );
};

export default useFeatures;
